import React, { useContext } from "react";
import { Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import style from "./Custody.module.scss";
import { Mode } from "../../../utils";

const Footer = ({ toggle, buttons, actions, dispatch }) => {
  const { precheck, modify, confirm } = buttons;

  return (
    <div>
      <Button color="light" onClick={() => toggle()}>
        Close
      </Button>{" "}
      {modify.visible && (
        <Button color="light" onClick={() => dispatch({ type: "CHANGE_MODE", mode: Mode.EDIT })}>
          {"Modify"}
        </Button>
      )}{" "}
      {precheck.visible && (
        <LaddaButton
          className={classnames("btn btn-ladda btn-primary")}
          loading={precheck.loading}
          onClick={() => actions.precheck()}
          data-style={EXPAND_RIGHT}
        >
          {"Pre check"}
        </LaddaButton>
      )}
      {confirm.visible && (
        <LaddaButton
          className={classnames("btn btn-ladda btn-primary")}
          loading={confirm.loading}
          onClick={() => actions.confirm()}
          data-style={EXPAND_RIGHT}
        >
          {"Confirm"}
        </LaddaButton>
      )}
    </div>
  );
};

export default Footer;
